// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";

// Settings page components
import BaseLayout from "layouts/settings/BaseLayout";
import Users from "layouts/settings/Users";
import UltiproConfiguration from "layouts/settings/UltiproConfiguration";
import UTAConfiguration from "layouts/settings/UTAConfiguration";
import SimplitimeConfiguration from "layouts/settings/SimplitimeConfiguration";
import { useEffect, useMemo, useState } from "react";

function Settings() {
  const [menu, setMenu] = useState(0);

  const menuContent = useMemo(() => {
    switch (menu) {
      case 0:
        return <Users />;
      case 1:
        return <UltiproConfiguration />;
      case 2:
        return <UTAConfiguration />;
      case 3:
        return <SimplitimeConfiguration />;
      default:
        return null;
    }
  }, [menu]);

  useEffect(() => {
    if (menu > 3 && menu < 0) {
      setMenu(0);
    }
  }, [menu, setMenu]);

  return (
    <BaseLayout menu={menu} setMenu={setMenu}>
      <MDBox mt={4}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={12}>
            <MDBox mb={3}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  {menuContent}
                </Grid>
              </Grid>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </BaseLayout>
  );
}

export default Settings;
